import * as R from 'ramda'

const SELECTED_CURRENT_TOURNAMENT = 'SELECTED_CURRENT_TOURNAMENT'
const CLEARED_CURRENT_TOURNAMENT = 'CLEARED_CURRENT_TOURNAMENT'

export const selectTournament = (tenant, tournament) => ({
  type: SELECTED_CURRENT_TOURNAMENT,
  payload: {
    tenant,
    tournament,
  },
})

export const clearTournament = () => ({ type: CLEARED_CURRENT_TOURNAMENT })

const initialState = {
  currentTenant: undefined,
  currentTournament: undefined,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_CURRENT_TOURNAMENT:
      return {
        ...state,
        currentTenant: action.payload.tenant,
        currentTournament: action.payload.tournament,
      }
    case CLEARED_CURRENT_TOURNAMENT:
      return {
        ...state,
        currentTenant: undefined,
        currentTournament: undefined,
      }
    default:
      return state
  }
}

export default reducer

export const selectTournamentInfo = (state) => {
  const tournamentsState = state && state.tournaments
  const currentTournament = tournamentsState && tournamentsState.currentTournament

  return {
    name: R.prop('name', currentTournament),
    tournamentId: R.prop('id', currentTournament),
    tenant: R.path(['tournaments', 'currentTenant'], state),
    public: currentTournament?.public,
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/tournaments.ts